import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackMixpanelPageView } from 'helpers/post';
import { connect } from 'react-redux';
import { brandsLogo } from 'scenes/V3/ATLandingPage/assets';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import {
  FAQSection,
  HowItWorksSection,
  TestimonialsSection,
  WelcomeSection,
  JoinATSection,
} from './Sections';
import './ATLandingPage.scss';

class ATLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: {
        active: false,
      },
    };
    this.brandsCarouselRef = React.createRef();
  }

  componentDidMount() {
    trackMixpanelPageView('/athletic-trainers');

    if (this.brandsCarouselRef.current) {
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow(this.brandsCarouselRef));
      this.resizeObserver.observe(this.brandsCarouselRef.current);
    }

    // Query params are automatically captured by withQueryParamCapture HOC

    setTimeout(() => {
      this.initScrollAnimations();
    }, 100);
  }

  initScrollAnimations = () => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.15,
    };

    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');

          this.scrollObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.scroll-animate');
    animatedElements.forEach(el => this.scrollObserver.observe(el));
  };

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.scrollObserver) this.scrollObserver.disconnect();
  }

  checkOverflow = ref => {
    if (!ref.current) return false;

    const isActive = this.brandsCarouselRef.current.scrollWidth > window.innerWidth;

    this.setState(prevState => ({
      ...prevState,
      brands: {
        ...prevState.brands,
        active: isActive,
      },
    }));

    return isActive;
  };

  onImReady = () => {
    trackMixpanelPageView('ATLandingPageGetStarted', this.props.user);

    this.props.history.push('/athletic-trainers/create-account');
  };

  institutionsLogoSlides = () => {
    return brandsLogo.map((image, index) => (
      <div className="embla__slide brands" key={`brand-logo-${index}`}>
        <img
          src={image.imageUrl}
          alt={`Institution logo ${index + 1}`}
          className="institution-logo"
          width={image.width}
          height={image.height}
          style={image.objectFit ? { objectFit: image.objectFit } : undefined}
        />
      </div>
    ));
  };

  render() {
    return (
      <div className="atLandingPage">
        <main className="content">
          <WelcomeSection
            onImReady={this.onImReady}
            institutionsLogoSlides={this.institutionsLogoSlides}
            brandsCarouselRef={this.brandsCarouselRef}
            brands={this.state.brands}
          />
          <HowItWorksSection />
          <TestimonialsSection />
          <FAQSection />
          <JoinATSection onImReady={this.onImReady} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.session.currentUser,
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(withRouter(connect(mapStateToProps)(ATLandingPage)));
